import { Controller } from "@hotwired/stimulus"
import { logger } from "../logger"

// Connects to data-controller="selected-columns"
// Manages the empty state placeholder in the report designer center panel
export default class extends Controller {
  static targets = ["emptyPlaceholder", "columnsList"]

  connect() {
    if (!this.hasEmptyPlaceholderTarget || !this.hasColumnsListTarget) {
      console.error("[Selected Columns] Missing required targets!")
      return
    }

    this.updateEmptyState()

    // Listen for column additions/removals from sortable controller
    this.element.addEventListener('selected-columns:update', (e) => {
      this.updateEmptyState()
    })
  }

  updateEmptyState() {
    if (!this.hasEmptyPlaceholderTarget || !this.hasColumnsListTarget) {
      return
    }

    // Count visible column items (exclude items marked for destruction)
    const columnItems = this.columnsListTarget.querySelectorAll('.column-item')
    const visibleColumns = Array.from(columnItems).filter(item => {
      const destroyInput = item.querySelector('input[name$="[_destroy]"]')
      return !destroyInput || destroyInput.value === 'false' || destroyInput.value === ''
    })

    const hasColumns = visibleColumns.length > 0

    // Show placeholder when no columns, hide when there are columns
    if (hasColumns) {
      this.emptyPlaceholderTarget.classList.add('d-none')
    } else {
      this.emptyPlaceholderTarget.classList.remove('d-none')
    }

    // Update column count badge
    this.updateColumnCount(visibleColumns.length)
  }

  hidePlaceholderForDrag() {
    if (!this.hasEmptyPlaceholderTarget) return
    this.emptyPlaceholderTarget.classList.add('d-none')
  }

  showPlaceholderAfterDrag() {
    if (!this.hasEmptyPlaceholderTarget || !this.hasColumnsListTarget) return

    // Check if list is still empty
    const columnItems = this.columnsListTarget.querySelectorAll('.column-item')
    const visibleColumns = Array.from(columnItems).filter(item => {
      const destroyInput = item.querySelector('input[name$="[_destroy]"]')
      return !destroyInput || destroyInput.value === 'false' || destroyInput.value === ''
    })

    // Only show placeholder if still empty
    if (visibleColumns.length === 0) {
      this.emptyPlaceholderTarget.classList.remove('d-none')
    }
  }

  updateColumnCount(count) {
    const badge = document.querySelector('[data-selected-columns-count="true"]')
    if (badge) {
      badge.textContent = count
    }
  }
}
